/**
 * =============================================================
 * AADHAV ACADEMY – ADMIN FEE MASTER THUNK
 * Role: Admin
 * Scope: Async actions for fetching tenant fee templates
 * Standard: Enterprise / MNC Level
 * =============================================================
 */

import { createAsyncThunk } from "@reduxjs/toolkit";
import { getFeeMasters } from "../../api/admin/fee_master.api";

/* ================= FETCH FEE MASTERS ================= */

export const fetchFeeMasters = createAsyncThunk(
  "admin/feeMaster/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getFeeMasters();

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res.data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch fee templates.");
    }
  }
);